import { Box, Divider, Group, Stack } from "@mantine/core"
import { useAppState } from "src/state"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { ThreadStatusTag } from "./AgencyOperationsAdminThreads"
import { AgencyOperationsAdminThreadMessages } from "./messages/AgencyOperationsAdminThreadMessages"
import { AgencyOperationsAdminThreadPreview } from "src/components/agency/operations/administrator/threads/AgencyOperationsAdminThreadPreview"

export function AgencyOperationsAdminThreadOverlay() {

    const { currentItem } = useAppState(state => state.threads)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.subject}`}
                    badge={<ThreadStatusTag status={currentItem?.thread_status!} />}
                    renderAction={
                        <Group gap="sm">

                        </Group>
                    }
                    preview={<AgencyOperationsAdminThreadPreview />}
                />
            }
        >

            <Stack gap="sm">
                <Divider
                    my="0"
                    variant="dashed"
                    labelPosition="left"
                    label={<Box ml={5}>Messages</Box>}
                />
                <AgencyOperationsAdminThreadMessages />
            </Stack>

        </DrawerPageLayout>
    )

}